module.exports = __webpack_public_path__ + "static/media/share-outline.14b99597.svg";